import { Component, computed, inject, Signal } from "@angular/core";
import { GamesStore } from "../../stores/offers/games.store";
import { AppsStore } from "../../stores/offers/apps.store";
import { QuestSchedulesStore } from "../../stores/quests/quest-schedule.store";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { QuestConditionType } from "@playcharge/common/models/backend/quests/quest-condition-type";
import { QuestTriggerType } from "@playcharge/common/models/backend/quests/quest-trigger-type";
import { BackOfficeOfferViewModel } from "@playcharge/common/models/backend/offers/backoffice/backoffice-offer-view-model";
import { FormControl } from "@angular/forms";
import { MatChipInputEvent } from "@angular/material/chips";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { QuestTemplatesStore } from "../../stores/quests/quest-templates.store";

@Component({
    template: "",
})
export abstract class QuestBaseComponent {
    public router: Router = inject(Router);
    public toastrService: ToastrService = inject(ToastrService);
    public schedulesStore: QuestSchedulesStore = inject(QuestSchedulesStore);
    public templatesStore: QuestTemplatesStore = inject(QuestTemplatesStore);
    public gamesStore: GamesStore = inject(GamesStore);
    public appsStore: AppsStore = inject(AppsStore);

    public offers: Signal<BackOfficeOfferViewModel[]> = computed<BackOfficeOfferViewModel[]>(() =>
        this.gamesStore
            .entities()
            .concat(this.appsStore.entities())
            .sort((a, b) => a.affiseOfferId - b.affiseOfferId),
    );

    public QuestTriggerType: typeof QuestTriggerType = QuestTriggerType;
    public QuestConditionType: typeof QuestConditionType = QuestConditionType;

    public addGoalId(event: MatChipInputEvent): void {
        const value: number = Number(event.value.trim());

        if (isNaN(value)) {
            return;
        }

        const control: FormControl = this.goalIdsControl;

        if (control.value) {
            control.patchValue([...control.value, value]);
        } else {
            control.patchValue([value]);
        }

        event.chipInput.clear();
    }

    public removeGoalId(goalId: number): void {
        const control: FormControl = this.goalIdsControl;

        if (control.value) {
            const index = control.value.indexOf(goalId);

            if (index >= 0) {
                control.patchValue([
                    ...control.value.slice(0, index),
                    ...control.value.slice(index + 1),
                ]);
            }
        }
    }

    public abstract get goalIdsControl(): FormControl<Nullable<number[]>>;
}
